module.exports = {"menuText":"Меню","materialsText":"Статьи","main":[],"langs":[{"title":"English","slug":"en"},{"title":"русский","slug":"ru"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/top-nav.ru.json
// module id = 187
// module chunks = 0